export default __webpack_public_path__ + "static/media/zx9-on-table.ac5b0cc3.png";